import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mx-4" },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c(
                VTabs,
                {
                  attrs: { centered: "", "icons-and-text": "" },
                  model: {
                    value: _vm.categoria,
                    callback: function ($$v) {
                      _vm.categoria = $$v
                    },
                    expression: "categoria",
                  },
                },
                [
                  _c(VTabsSlider, { attrs: { color: "secondary" } }),
                  _vm._l(_vm.categorias.length, function (i) {
                    return _c(
                      VTab,
                      {
                        key: i,
                        staticClass: "mt-3",
                        attrs: { href: "#" + _vm.categorias[i - 1].id },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "grey--text text--darken-2" },
                          [_vm._v(_vm._s(_vm.categorias[i - 1].descricao))]
                        ),
                        _c(
                          VIcon,
                          {
                            attrs: {
                              color:
                                _vm.categorias[i - 1].id === _vm.categoria
                                  ? "secondary"
                                  : "grey",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.categorias[i - 1].icone) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.categoria === "RelatorioPerfilGeral" ||
      _vm.categoria === "RelatorioPerfilUnidade"
        ? _c(
            VRow,
            { staticClass: "justify-end mt-10" },
            [
              _c(VSpacer),
              _c(
                VCol,
                { attrs: { cols: "6", md: "4" } },
                [
                  _c(VSelect, {
                    staticClass: "mr-2 ml-4",
                    attrs: {
                      items: _vm.tipos,
                      "item-text": "descricao",
                      "item-value": "id",
                      label: "Selecione o tipo de monitoramento",
                      dense: "",
                    },
                    model: {
                      value: _vm.tipo,
                      callback: function ($$v) {
                        _vm.tipo = $$v
                      },
                      expression: "tipo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.categoria === "RelatorioPerfilParticipacao" ||
      _vm.categoria === "RelatorioPerfilGeral"
        ? _c(
            VRow,
            [
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [_c("app-title", { attrs: { texto: "SELEÇÃO DAS UNIDADES" } })],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c("selecao-unidade", {
                    model: {
                      value: _vm.selecaoUnidade,
                      callback: function ($$v) {
                        _vm.selecaoUnidade = $$v
                      },
                      expression: "selecaoUnidade",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c(_vm.categoria, {
                tag: "component",
                attrs: {
                  "selecao-unidade": _vm.selecaoUnidade,
                  "tipo-monitoramento": _vm.tipo,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }